(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexible-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.FlexiAnimations) return;

    var OFFSCREEN = 'scroll-trigger--offscreen';
    var DESIGN = 'scroll-trigger--design-mode';

    function onIntersection(entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove(OFFSCREEN);
        observer.unobserve(entry.target);
      });
    }

    function blocks(root) {
      return Array.prototype.filter.call(root.querySelectorAll('.flexi-library[id]'), function (el) {
        if (el.closest('.flexi-equal-card, .blaze-slider')) return false;
        if (el.closest('.flexi-logo-marquee, .flexi-layout-marquee')) return false;
        return true;
      });
    }

    function isTopLevel(wrapper, block) {
      var parent = block.parentElement;
      if (!parent) return false;
      return parent === wrapper || (parent.classList.contains('shopify-block') && parent.parentElement === wrapper);
    }

    function prepare(scope) {
      scope.querySelectorAll('.flexi-section-wrapper.scroll-trigger').forEach(function (wrapper) {
        var all = blocks(wrapper);
        all.forEach(function (block) {
          if (!isTopLevel(wrapper, block)) return;

          var leaves = all.filter(function (el) {
            return el !== block && block.contains(el) && !all.some(function (other) {
              return other !== el && el.contains(other);
            });
          });

          if (!leaves.length) {
            block.classList.add('scroll-trigger', 'animate--fade-in', OFFSCREEN);
            return;
          }

          leaves.forEach(function (leaf, index) {
            leaf.classList.add('scroll-trigger', 'animate--slide-in', OFFSCREEN);
            leaf.style.setProperty('--animation-order', index);
          });
        });
      });
    }

    function init(root, designMode) {
      var scope = root && root.querySelector ? root : document;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      prepare(scope);

      var elements = Array.prototype.filter.call(scope.getElementsByClassName('scroll-trigger'), function (element) {
        return element.classList.contains('animate--fade-in') || element.classList.contains('animate--slide-in');
      });
      if (!elements.length) return;

      if (designMode) {
        elements.forEach(function (element) {
          element.classList.add(DESIGN);
          element.classList.remove(OFFSCREEN);
        });
        return;
      }

      var observer = new IntersectionObserver(onIntersection, {
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(function (element) {
        if (element.dataset.flexiScrollBound) return;
        element.dataset.flexiScrollBound = 'true';
        observer.observe(element);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document, false); });
    } else {
      init(document, false);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target, window.Shopify && Shopify.designMode);
    });

    window.FlexiAnimations = { init: init };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jg-authorized-dealer-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jg-dealer-directory')) {
    customElements.define('jg-dealer-directory', class extends HTMLElement {
      connectedCallback() {
        // Deferring also lets Shopify finish inserting children on editor reloads.
        queueMicrotask(() => {
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        if (this.initialized) return;
        this.rows = Array.from(this.querySelectorAll('[data-dealer-row]'));
        this.regionButtons = Array.from(this.querySelectorAll('[data-region-button]'));
        this.pageSizeSelect = this.querySelector('[data-page-size]');
        this.count = this.querySelector('[data-result-count]');
        this.heading = this.querySelector('[data-region-title]');
        this.pagination = this.querySelector('[data-pagination]');
        this.previous = this.querySelector('[data-page-action="previous"]');
        this.next = this.querySelector('[data-page-action="next"]');
        this.emptyMessage = this.querySelector('[data-empty-message]');
        if (!this.pageSizeSelect || !this.heading || !this.pagination) return;

        this.pageSize = this.dataset.defaultPageSize === '20' ? 20 : 10;
        this.pageSizeSelect.value = String(this.pageSize);
        this.page = 1;
        const requested = this.dataset.defaultRegion;
        this.region = ['usa', 'international'].includes(requested)
          ? requested
          : (this.rows.some(row => this.getRegion(row) === 'usa') ? 'usa' : 'international');

        this.onClick = this.handleClick.bind(this);
        this.onChange = this.handleChange.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = true;
        this.render();
        this.querySelector('[data-region-controls]').hidden = false;
        this.querySelector('[data-toolbar]').hidden = false;
        this.heading.hidden = false;
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = false;
      }

      getRegion(row) {
        return row.dataset.dealerRegion === 'usa' ? 'usa' : 'international';
      }

      matchingRows() {
        return this.rows.filter(row => this.getRegion(row) === this.region);
      }

      handleClick(event) {
        const regionButton = event.target.closest('[data-region-button]');
        if (regionButton && this.contains(regionButton)) {
          this.region = regionButton.dataset.regionButton;
          this.page = 1;
          this.render();
          return;
        }
        const pageButton = event.target.closest('[data-page-action]');
        if (!pageButton || !this.contains(pageButton) || pageButton.disabled) return;
        this.page += pageButton.dataset.pageAction === 'next' ? 1 : -1;
        this.render();
        this.heading.focus({ preventScroll: true });
        this.heading.scrollIntoView({ block: 'start', behavior: 'auto' });
      }

      handleChange(event) {
        if (event.target !== this.pageSizeSelect) return;
        this.pageSize = this.pageSizeSelect.value === '20' ? 20 : 10;
        this.page = 1;
        this.render();
      }

      handleBlockSelect(event) {
        // Reveal the selected dealer even if it is on another region or page.
        const row = this.rows.find(item => item.dataset.blockId === event.detail?.blockId)
          || event.target.closest('[data-dealer-row]');
        if (!row || !this.rows.includes(row)) return;
        this.region = this.getRegion(row);
        this.page = Math.floor(this.matchingRows().indexOf(row) / this.pageSize) + 1;
        this.render();
        row.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }

      render() {
        const matches = this.matchingRows();
        const total = matches.length;
        const pages = Math.max(1, Math.ceil(total / this.pageSize));
        this.page = Math.max(1, Math.min(this.page, pages));
        const start = (this.page - 1) * this.pageSize;
        const end = Math.min(start + this.pageSize, total);
        const visible = new Set(matches.slice(start, end));
        this.rows.forEach(row => { row.hidden = !visible.has(row); });
        this.regionButtons.forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.regionButton === this.region));
        });
        const regionLabel = this.region === 'usa' ? 'USA' : 'International';
        this.heading.textContent = regionLabel + ' dealers';
        this.count.textContent = total
          ? `Showing ${start + 1}–${end} of ${total} ${regionLabel} ${total === 1 ? 'dealer' : 'dealers'}`
          : `0 ${regionLabel} dealers`;
        this.querySelector('[data-page-number]').textContent = `Page ${this.page} of ${pages}`;
        this.previous.disabled = this.page === 1;
        this.next.disabled = this.page === pages;
        this.pagination.hidden = pages <= 1;
        this.querySelector('[data-column-header]').hidden = total === 0;
        this.emptyMessage.hidden = total > 0;
        this.emptyMessage.textContent = `No ${regionLabel} dealers are currently listed.`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
